import { CHART_IDS, isDashboardChartEnabled } from "../../../../config/featureConfig";
import DailyTrafficChart from "./components/charts/DailyTrafficChart";
import TopClickedProductsChart from "./components/charts/TopClickedProductsChart";
import TopViewedProductsChart from "./components/charts/TopViewedProductsChart";
import TopSearchedCategories from "./components/charts/TopSearchedCategories";
import MonthlyBilling from "./components/charts/MonthlyBilling";

export const CHART_TAB_DEFS = [
  { id: CHART_IDS.DAILY_TRAFFIC, title: "Traffico", Component: DailyTrafficChart, singleViewSurface: "card" },
  {
    id: CHART_IDS.TOP_PRODUCTS_BY_CLICK,
    title: "Prodotti più cliccati",
    Component: TopClickedProductsChart,
    singleViewSurface: "plain",
  },
  { id: CHART_IDS.TOP_PRODUCTS_BY_VIEW, title: "Prodotti più visualizzati", Component: TopViewedProductsChart, singleViewSurface: "card" },
  {
    id: CHART_IDS.TOP_CATEGORIES_BY_SEARCH,
    title: "Categorie più cercate",
    Component: TopSearchedCategories,
    singleViewSurface: "plain",
  },
  { id: CHART_IDS.MONTHLY_REVENUE, title: "Fatturato mensile", Component: MonthlyBilling, singleViewSurface: "card" },
];

export function getEnabledDashboardCharts() {
  return CHART_TAB_DEFS.filter((def) => isDashboardChartEnabled(def.id));
}
